var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"dense",attrs:{"dark":_vm.darkTheme}},[_c('router-view'),_c('notifications',{attrs:{"group":"success","position":"bottom left"}}),_c('notifications',{attrs:{"group":"error","position":"bottom left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }